.buttonLink {
    display: flex;
    align-items: center;
    background-color: transparent;
    border-radius: 9px;
    border: none;
    box-shadow: none;
    padding: 6px 0px;
    margin: 0px;
    text-align: left;
    text-decoration: none;
    width: fit-content;
    overflow-wrap: break-word;
}

.buttonLink:hover,
.buttonLink:hover:enabled,
.buttonLink:active,
.buttonLink:focus {
    background-color: #00000020 !important;
    border-color: transparent !important;
    text-decoration: none;
}

.buttonLink:disabled {
    background-color: transparent !important;
}

.linkStyledAsButton,
.linkStyledAsButton:hover, .linkStyledAsButton:active, .linkStyledAsButton:visited {
    text-decoration: none;
    color: inherit;
    display: flex;
    padding: 6px 0px;
    margin: 0px;
}

.newTabIconSmall {
    margin-left: 0.3em;
    /* height and width are equal to the font-size of our Text's "LinkTextSmall" variant. */
    height: 0.688rem;
    width: 0.688rem;
    color: var(--hps-light-blue);
}

.newTabIconLarge {
    margin-left: 0.3em;
    /* height and width are equal to the font-size of our Text's "LinkTextLarge" variant. */
    height: 1.063rem;
    width: 1.063rem;
    color: var(--hps-light-blue);
}

.overflowDots,
.overflowDotsDarkGray,
.overflowDotsWhite {
    height: 20px;
}

.overflowDotsDarkGray {
    color: var(--hps-gray);
}

.overflowDotsWhite {
    color: var(--hps-white);
}

.primary,
.secondary,
.primaryAsLink,
.secondaryAsLink,
.danger,
.primaryDropdown :global(.btn-primary),
.secondaryDropdown :global(.btn-primary) {
    height: 40px;
    padding: 6px 16px;
    border-radius: 9px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: var(--hps-primary-font);
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.75;
    letter-spacing: 0.043rem;
    text-transform: uppercase;
    box-shadow: 0px 3px 1px -2px #05263730, 0px 2px 2px 0px #05263724, 0px 1px 5px 0px #0526371f;
    transition: background-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    white-space: nowrap;
}

.primary,
.primaryAsLink,
.primaryDropdown :global(.btn-primary) {
    background-color: var(--hps-dark-blue);
    color: var(--hps-white);
    border: none;
}

.secondary,
.secondaryAsLink,
.secondaryDropdown :global(.btn-primary) {
    background-color: var(--hps-white);
    color: var(--hps-dark-blue);
    border: 1px solid;
}

.danger {
    background-color: var(--hps-red);
    color: var(--hps-white);
    border: none;
}

/* Button States */
/* Change the button text to white when hovering the mouse over it, but only if it is not disabled. The style for a file input needs to be defined separately because it has no enabled/disabled attributes. */
.primary:hover:enabled,
.primary:active,
.primaryAsLink:hover,
.primaryAsLink:active,
.primaryDropdown :global(.btn-primary):hover,
.primaryDropdown :global(.show > .btn-primary),
.primaryDropdown :global(.btn-primary:not(:disabled):not(.disabled):active) {
    background-color: #000d1e;
    cursor: pointer;
    box-shadow: 0px 6px 2px -1px #05263730, 0px 4px 4px 0px #05263724, 0px 2px 10px 0px #0526371f;
}

.secondary:hover:enabled,
.secondary:active,
.secondaryAsLink:hover,
.secondaryAsLink:active,
.secondaryDropdown :global(.btn-primary):hover,
.secondaryDropdown :global(.show > .btn-primary),
.secondaryDropdown :global(.btn-primary:not(:disabled):not(.disabled):active) {
    color: var(--hps-dark-blue);
    cursor: pointer;
    background-color: #031a2610;
    box-shadow: 0px 3px 1px -2px #05263730, 0px 2px 2px 0px #05263724, 0px 1px 5px 0px #0526371f;
}

.danger:hover:enabled,
.danger:active {
    cursor: pointer;
    background-color: #c31c2c;
    box-shadow: 0px 3px 1px -2px #05263730, 0px 2px 2px 0px #05263724, 0px 1px 5px 0px #0526371f;
}

.primary:disabled,
.secondary:disabled,
.primaryDropdown:disabled,
.secondaryDropdown:disabled,
.danger:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.isLoading {
    opacity: 1 !important;
    cursor: not-allowed !important;
}

/* Styles for the icon within a button, including animation. */
.icon,
.iconButtonIcon,
.iconButtonIconDisabled {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    margin: 0px 5px 0px 0px;
}
.isLoading .icon {
    animation: spin 1s infinite linear;
}
.primary .icon,
.secondary .icon,
.primaryAsLink .icon,
.secondaryAsLink .icon,
.primaryDropdown .icon,
.secondaryDropdown .icon {
    color: var(--hps-light-blue);
}
.danger .icon {
    color: var(--hps-white);
}

.iconButtonIcon,
.iconButtonIconDisabled {
    font-size: 1.5rem;
    margin: 0px;
}

.iconButtonIconDisabled {
    color: var(--hps-gray);
}

@keyframes spin {
    from {
        transform: scale(1) rotate(0deg);
    }
    to {
        transform: scale(1) rotate(360deg);
    }
}

/* Give drop-down menus a 3D appearance and set the width. */
.dropdownButtonMenuDefaultWidth {
    background-color: var(--hps-white);
    box-shadow: 0 2px 4px 0 ;
}
.dropdownButtonMenuExtraWidth {
    background-color: var(--hps-white);
    box-shadow: 0 2px 4px 0 ;
    width: 350px;
}

/* Styles for the elements that appear when clicking a dropdown button. */
.dropdownItem {
    font-family: var(--hps-primary-font);
    font-size: 0.813rem;
    font-weight: 500;
    letter-spacing: 0.013rem;
    white-space: normal;
}
.dropdownItemIcon {
    color: var(--hps-dark-blue);
    margin: 0px 5px 0px 0px;
}

/* IconDropdownButton and TextDropdownButton: Hide the default background and border. */
#iconAndTextDropdownButtonContainer .iconAndTextDropdownButtonToggle {
    background-color: transparent;
    border-color: transparent;
    box-shadow: none;
}

/*
TextDropdownButton: Ensure the text and down arrow are on the same line.
Note that the way this is written it will also apply to IconDropdownButton, but in reality it has no effect on IconDropdownButton since there is only a single child element for that.
*/
.iconAndTextDropdownButtonToggle {
    display: flex;
    align-items: center;
}

/* TextDropdownButton: Set the spacing between the text and the down arrow. */
.textDropdownButtonArrowSpacing {
    padding-right: 10px;
}

/* IconDropdownButton and TextDropdownButton: Set the color for the icons and text. */
.iconAndTextDropdownButtonColor {
    color: var(--hps-dark-blue);
}
